import React from "react"
import {StyledStandardSingleFacetLabel} from "./components"
import {FacetState} from "../../../../../../../models/FacetsState"

interface StandardSingleFacetLabelProps {
    facet: FacetState
}

export const StandardSingleFacetLabel = ({facet}: StandardSingleFacetLabelProps) => {
    return <StyledStandardSingleFacetLabel $isDisabled={facet.d}>{facet.n}</StyledStandardSingleFacetLabel>
}

export default StandardSingleFacetLabel
